import Vue from "vue";
import Vuetify from "vuetify";
import colors from "./colors";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  directives: {
    Touch,
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.shades.black,
        secondary: colors.grey.darken3,
        accent: colors.blue.accent1,
        error: colors.red.lighten1,
        info: colors.indigo.lighten1,
        success: colors.green.lighten4,
        warning: colors.red.lighten1,
        unselect: colors.grey.lighten2,
        background_base: colors.shades.white,
        background_main: colors.grey.lighten4,
        emons_color: colors.indigo.darken4,
        button_color: colors.shades.black,
        button_toggle_color: colors.grey.darken3,
        consult_on: colors.pantone.main,
        consult_off: colors.shades.black,
        basic: colors.pantone.main,
        black: colors.pantone.black,
        grey3: colors.pantone.grey3,
        grey2: colors.pantone.grey2,
        grey1: colors.pantone.grey1,
        brown4: colors.pantone.brown4,
        brown3: colors.pantone.brown3,
        brown2: colors.pantone.brown2,
        brown1: colors.pantone.brown1,
        pink3: colors.pantone.pink3,
        pink2: colors.pantone.pink2,
        pink1: colors.pantone.pink1,
        orange: colors.pantone.orange,
        yellow: colors.pantone.yellow,
        skyblue: colors.pantone.skyblue,
        navy: colors.emons.navy,
        emons_black: colors.emons.black,
      },
      dark: {
        primary: colors.shades.white,
        secondary: colors.grey.lighten4,
        accent: colors.blue.accent4,
        error: colors.red.darken1,
        info: colors.indigo.darken1,
        success: colors.green.darken4,
        warning: colors.red.darken4,
        unselect: colors.grey.lighten2,
        background_base: colors.shades.white,
        background_main: colors.grey.lighten4,
        emons_color: colors.indigo.darken4,
        button_color: colors.shades.white,
        button_toggle_color: colors.grey.lighten2,
      },
    },
  },
});
